export default function GrayRefreshIcon() {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="37" height="37" rx="3.5" fill="white" />
        <rect
          x="0.5"
          y="0.5"
          width="37"
          height="37"
          rx="3.5"
          stroke="#D7DFE9"
        />
        <path
          d="M22.3868 20.9887H25.7618M25.7618 20.9887V24.3637M25.7618 20.9887L23.3752 23.3752C22.8007 23.9498 22.1186 24.4056 21.3679 24.7165C20.6172 25.0275 19.8126 25.1875 19 25.1875C18.1875 25.1875 17.3829 25.0275 16.6322 24.7165C15.8815 24.4056 15.1994 23.9498 14.6248 23.3752M15.6133 17.0113H12.2383M12.2383 17.0113V13.6363M12.2383 17.0113L14.6248 14.6248C15.1994 14.0502 15.8815 13.5944 16.6322 13.2835C17.3829 12.9725 18.1875 12.8125 19 12.8125C19.8126 12.8125 20.6172 12.9725 21.3679 13.2835C22.1186 13.5944 22.8007 14.0502 23.3752 14.6248"
          stroke="#AFBACA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
